import "./Dialog.scss";

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import LicenceList from "../Licences/LicenceList";
import  Button  from '@mui/material/Button';


const ValidateListDialog = ({list, open, handleClose, title, handleOk}) => {
    return ( <Dialog 
        PaperProps={{
          sx: {
            minHeight: 750
          }
        }}
          className="editdialog" 
          open={open} 
          fullWidth={true}
          maxWidth={"lg"}
          >
          <DialogTitle className="dialogtitle">
            <div className="left">
            {title}
            </div>
              <IconButton onClick={handleClose} className="right">
                <CloseIcon />
              </IconButton>
          </DialogTitle>
            <DialogContent  className="dialogcontent">
                    <LicenceList list={list} handleClose={handleClose} />
                    <div style={{float:"right", backgroundColor:"lightgrey", padding:"10px"}}>
                        Do you whish to proceed?
                        <Button style={{marginLeft:"20px"}} variant="contained" className="button" onClick={handleOk}>YES</Button>
                        <Button style={{marginLeft:"20px"}} variant="contained" className="button" onClick={handleClose}>NO</Button>
                    </div>
            </DialogContent>
        </Dialog>
    )

}

export default ValidateListDialog;